// extracted by mini-css-extract-plugin
module.exports = {"spinning":"styles_spinning__LgAlS","spin":"styles_spin__6tCGT"};